import { FEATURES } from 'src/app/common/constants/app.constants';
import { RbacService } from './shared/services/rbac/rbac.service';
import { Observable, filter, map, takeUntil } from 'rxjs';
import { LoaderService } from './shared/services/loader/loader.service';
import { NavigationBarComponent } from 'src/app/components/navigation-bar/navigation-bar.component';
import { Router, RouterModule } from '@angular/router';
import { Component, HostListener, OnInit } from '@angular/core';

import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { AuthenticationService } from './authentication/authentication.service';
import { Subject } from 'rxjs';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';

import { User } from './shared/constants/user-info';
import { SharedService } from './shared/services/shared.service';
import { EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { AdobeAnalyticsService } from './shared/services/adobe-analytics/adobe-analytics.service';
import { ANTI_VIRUS_SCAN_STATUS } from './shared/constants/antivirus-scan-constant';
import { AppLoggerService } from './shared/services/app-logger.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterModule, MatDialogModule, MatButtonModule, NavigationBarComponent, AsyncPipe, NgOptimizedImage],
    providers: []
})
export class AppComponent implements OnInit {
  title = 'Test-AI';
  public isLoading$: Observable<boolean>;
  public isLoggedIn$: Observable<boolean>;
  public isScanning$: Observable<boolean>;
  actionDataFetched: boolean = false;
  userData: User;
  isIframe: boolean = false;
  private readonly _destroying$ = new Subject<void>();
  features = FEATURES
  hideNavBar: boolean = false;
  antivirusScanStatus: string = ANTI_VIRUS_SCAN_STATUS;

  constructor(
    private authService: AuthenticationService,
    private msalService: MsalService,
    private readonly loaderService: LoaderService,
    private readonly rbacService: RbacService,
    private readonly sharedService: SharedService,
    private msalBroadcastService: MsalBroadcastService,
    private location: Location,
    private router: Router,
    private adobeAnalyticService: AdobeAnalyticsService,
  ) {
    if (environment.isLocal) {
      this.loginRedirect();
    } else {
      const initialRoute = sessionStorage.getItem("SESSION_STORAGE_ROUTE_KEY");
      if (initialRoute == null && initialRoute != '' && this.location.path().includes('details/') &&
        !this.location.path().includes('-details/') && !this.location.path().includes('test-scenario') &&
        !this.location.path().includes('map-test-cases'))
        sessionStorage.setItem("SESSION_STORAGE_ROUTE_KEY", this.location.path())

      this.handleMsalSubscriptions();
    }
  }

  ngOnInit() {
    this.sharedService.getHideNavbar().subscribe((res) => {
      this.hideNavBar = res
    });
    this.isLoading$ = this.loaderService.getisLoading();
    this.isScanning$ = this.loaderService.getIsScanning();
    this.isLoggedIn$ = this.authService.getIsLoggedIn().pipe(map((res: boolean) => {
      if (res) {
        this.rbacService.getAllFeatures().subscribe(res => {
          let featureData;
          res?.forEach(val => {
            if (val.featureName.toLowerCase() === this.features?.menu?.toLowerCase()) {
              featureData = val;
            }
          })
          this.rbacService.getPermissionsForFeature(featureData._id).subscribe(res => {
            if (res) {
              this.rbacService.setActionDataForFeature(res);
              this.actionDataFetched = true;
            }
          })
        })
      }
      const initialRoute = sessionStorage.getItem("SESSION_STORAGE_ROUTE_KEY")
      if (initialRoute != null && initialRoute != '') {
        this.router.navigate([initialRoute]);
      }
      return res;
    }));
  }

  @HostListener('click', ['$event.target']) onClick(event) {
    if(environment.IS_ADOBE_ANALYTICS_ENABLED){
      if (event.outerText !== null && event.outerText !== '' && event.outerText !== undefined) {
        this.adobeAnalyticService.setApplicationName("TestAI");
        this.adobeAnalyticService.setPageName(event.url);
        this.adobeAnalyticService.setUserId();
        this.adobeAnalyticService.setActonName(event.outerText);
        this.adobeAnalyticService.trackActionEvent("actions");
        
        const originalWindowOpen = window.open;
        window.open = (url?: string, target?: string, features?: string) => {
          this.adobeAnalyticService.setLinkName(url);
          this.adobeAnalyticService.trackActionEvent('links');          
          return originalWindowOpen.call(window, url, target, features);
        };
      }
    }
  }

  loginRedirect() {
    if (environment.isLocal) {
      this.authService.triggerLocalAuth();
    } else {
      this.authService.msalAuthLogin();
    }
  }

  handleMsalSubscriptions() {
    this.msalService.handleRedirectObservable().subscribe();

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.authService.checkAndSetActiveAccount();
      });

    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS),
      )
      .subscribe((result: EventMessage) => {
        this.authService.handleLoginSuccess(result);
      });
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

}
